import {
  type AddressBookSearchApi,
  FILTERS_META_KEYS,
  type TimeZone,
  type TimeZoneApi,
  type TimeZones,
} from '../models';

const DEFAULT_TAKE = 200;

const META_KEYS = new Set<string>(FILTERS_META_KEYS);

export const inlineSearch = (filters: Record<string, string | number | undefined> | undefined) => {
  const result: Record<string, string | number | undefined> = {};

  for (const [k, v] of Object.entries(filters ?? {})) {
    if (!META_KEYS.has(k) && v !== '') {
      result[`InlineSearch[${k}]`] = v;
    }
  }

  return result;
};

export const paginate = (filters: { page?: number; limit?: number }, defaultTake = DEFAULT_TAKE) => {
  const take = filters.limit ?? defaultTake;
  const page = filters.page ?? 1;

  return {
    Skip: (page - 1) * take,
    Take: take,
  };
};

export const normalizeTimeZone = (timeZone: TimeZoneApi): TimeZone => {
  return {
    id: timeZone.ianaTimeZoneId,
    label: timeZone.displayName,
    value: timeZone.ianaTimeZoneId,
  };
};

export const normalizeTimeZones = (timeZones: TimeZoneApi[]): TimeZones => {
  const _timeZones = timeZones.map(normalizeTimeZone);
  return {
    list: _timeZones,
    map: _timeZones.reduce(
      (acc, timeZone) => {
        acc[timeZone.id] = timeZone;
        return acc;
      },
      {} as TimeZones['map'],
    ),
  };
};

export const normalizeAddressBookSearch = (results: AddressBookSearchApi | null): AddressBookSearchApi => {
  if (results === null) {
    return { data: [], total: 0 };
  }

  return results;
};
